import { httpBatchLink, createTRPCClient } from '@trpc/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import type { AppRouter } from '@fretgenius/server';
import { trpc } from './trpcCore';

function getApiUrl() {
  const val = import.meta.env.VITE_API_URL;
  return typeof val === 'string' && val.length > 0 ? val : 'http://localhost:4000/trpc';
}

const queryClient = new QueryClient();

export function TRPCProvider({ children }: { children: React.ReactNode }) {
  const client = createTRPCClient<AppRouter>({ links: [httpBatchLink({ url: getApiUrl() })] });
  return (
    <trpc.Provider client={client} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}
